import { render, staticRenderFns } from "./mychart1.vue?vue&type=template&id=3d8fffbf&scoped=true&"
import script from "./mychart1.vue?vue&type=script&lang=js&"
export * from "./mychart1.vue?vue&type=script&lang=js&"
import style0 from "./mychart1.vue?vue&type=style&index=0&id=3d8fffbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8fffbf",
  null
  
)

export default component.exports